import { Component, Inject, SimpleChanges } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef,
} from '@angular/material/dialog';
import { EditOfflineDonationComponent } from '../edit-offline-donation/edit-offline-donation.component';
import { FundraiserService } from 'src/app/pages/fundraiser/services/fundraiser.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf, DecimalPipe, DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

interface OfflineDonation {
	date: string;
	description: string;
	amount: number;
	id: number;
	currency: string;
}

let ELEMENT_DATA: OfflineDonation[] = [];
@Component({
    selector: 'app-view-summary',
    templateUrl: './view-summary.component.html',
    standalone: true,
    imports: [FlexModule, MatButtonModule, NgClass, ExtendedModule, NgIf, MatTableModule, MatIconModule, DecimalPipe, DatePipe]
})
export class ViewSummaryComponent {
	displayedColumns: string[] = ['date', 'description', 'amount'];
	currency: any;
	dataSource = new MatTableDataSource(ELEMENT_DATA);
	isLoading: boolean = true;
	constructor(
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			slug: string;
			isLoggedIn: string;
			isLoggedInUserAdmin: string;
		},
		public dialogRef: MatDialogRef<ViewSummaryComponent>,
		public fundraiserService: FundraiserService
	) {}

	ngOnInit(): void {
		this.isLoading = true;
		this.fundraiserService
			.getAllOfflineDonation(this.data.slug)
			.subscribe((response: any) => {
				this.isLoading = false;
				ELEMENT_DATA = this.dataFilter(response.data.result.details);
				this.dataSource = new MatTableDataSource(ELEMENT_DATA);
			});
		if (this.data.isLoggedInUserAdmin) {
			this.displayedColumns.push('action');
		}
	}

	getTotalAmount(): number {
		if (
			!this.dataSource ||
			!this.dataSource.data ||
			this.dataSource.data.length === 0
		) {
			return 0;
		}

		return this.dataSource.data.reduce((total: number, item: any) => {
			return total + parseFloat(item.amount);
		}, 0);
	}

	onCloseClick() {
		this.dialogRef.close();
	}

	openDialog(id: any): void {
		const data = this.dataSource.data.find((t: any) => t.id === id);
		const dialogRef = this.dialog.open(EditOfflineDonationComponent, {
			width: '80vh',
			data: { dataSource: data, slug: this.data.slug },
		});
		this.dialogRef.close(true);
	}

	dataFilter(sourceList: any) {
		if (!sourceList) {
			return [];
		} else {
			const filteredData = sourceList.map((source: any) => {
				const dateObj = new Date(source?.created_at);
				const formattedDate = dateObj.toLocaleDateString('en-US');
				return {
					date: formattedDate || 0,
					description: source?.description,
					amount: Math.round(parseFloat(source?.amount)),
					id: source?.id,
					currency: source?.currency,
				};
			});
			if (filteredData.length > 0) {
				this.currency = filteredData[0].currency;
			}

			return filteredData;
		}
	}
}
